import { render, staticRenderFns } from "./woernerSetComponent.vue?vue&type=template&id=2ede710c&"
import script from "./woernerSetComponent.vue?vue&type=script&lang=js&"
export * from "./woernerSetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Projekte/woerner-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ede710c')) {
      api.createRecord('2ede710c', component.options)
    } else {
      api.reload('2ede710c', component.options)
    }
    module.hot.accept("./woernerSetComponent.vue?vue&type=template&id=2ede710c&", function () {
      api.rerender('2ede710c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/single/woernerSetComponent.vue"
export default component.exports